import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["payeeField", "categoryField", "costCenterField", "destinationField", "bankAccountLabel", "payeeSelect", "destinationSelect", "categorySelect", "repeatField", "repeatCheckbox", "repeatCountContainer", "repeatCount", "repetitionField", "repetitionInput", "amountModeInput", "modeButton", "recurringPanel", "installmentPanel"]
  static values = { payeesUrl: String, categoriesUrl: String }

  connect() {
    this.toggleFields()
  }

  kindChanged() {
    this.toggleFields()
    this.clearIrrelevantFields()
    this.reloadPayees()
    this.reloadCategories()
  }

  toggleFields() {
    const isTransfer = this.selectedKind === "transfer"

    this.payeeFieldTarget.classList.toggle("hidden", isTransfer)
    this.categoryFieldTarget.classList.toggle("hidden", isTransfer)
    if (this.hasCostCenterFieldTarget) this.costCenterFieldTarget.classList.toggle("hidden", isTransfer)
    this.destinationFieldTarget.classList.toggle("hidden", !isTransfer)
    if (this.hasRepeatFieldTarget) this.repeatFieldTarget.classList.toggle("hidden", isTransfer)
    if (this.hasRepetitionFieldTarget) this.repetitionFieldTarget.classList.toggle("hidden", isTransfer)

    const label = this.bankAccountLabelTarget
    label.textContent = isTransfer ? label.dataset.labelTransfer : label.dataset.labelDefault
  }

  toggleRepeat() {
    if (!this.hasRepeatCheckboxTarget) return
    const checked = this.repeatCheckboxTarget.checked
    this.repeatCountContainerTarget.classList.toggle("hidden", !checked)
    if (!checked && this.hasRepeatCountTarget) this.repeatCountTarget.value = ""
  }

  setMode(event) {
    const mode = event.currentTarget.dataset.mode
    this.repetitionInputTarget.value = mode
    this.modeButtonTargets.forEach((button) => {
      button.classList.toggle("active", button.dataset.mode === mode)
    })
    this.recurringPanelTarget.classList.toggle("hidden", mode !== "recurring")
    this.installmentPanelTarget.classList.toggle("hidden", mode !== "installment")
  }

  setAmountMode(event) {
    const mode = event.currentTarget.dataset.amountMode
    this.amountModeInputTarget.value = mode
    event.currentTarget.parentElement.querySelectorAll(".segmented-control-item").forEach((button) => {
      button.classList.toggle("active", button.dataset.amountMode === mode)
    })
  }

  clearIrrelevantFields() {
    const isTransfer = this.selectedKind === "transfer"

    if (isTransfer) {
      this.payeeSelectTarget.value = ""
      if (this.hasCategorySelectTarget) this.categorySelectTarget.value = ""
    } else {
      if (this.hasDestinationSelectTarget) this.destinationSelectTarget.value = ""
    }
  }

  async reloadPayees() {
    await this.#reloadSelect(this.payeesUrlValue, this.payeeSelectTarget)
  }

  async reloadCategories() {
    if (!this.hasCategoriesUrlValue) return
    await this.#reloadSelect(this.categoriesUrlValue, this.categorySelectTarget)
  }

  get selectedKind() {
    const checked = this.element.querySelector('input[name="financial_transaction[kind]"]:checked')
    return checked ? checked.value : ""
  }

  async #reloadSelect(baseUrl, target) {
    const kind = this.selectedKind
    if (kind === "transfer") return

    const response = await fetch(`${baseUrl}?kind=${kind}`, {
      headers: {
        "Accept": "text/html",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      }
    })
    if (response.ok) target.innerHTML = await response.text()
  }
}
